import React from 'react';
import { CampaignListWidget } from './widget';

export const CampaignListPage: React.FC = () => <CampaignListWidget />;

